import { render, staticRenderFns } from "./View.vue?vue&type=template&id=f1ad9a4e&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
import style0 from "./View.vue?vue&type=style&index=0&id=f1ad9a4e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ad9a4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1ad9a4e')) {
      api.createRecord('f1ad9a4e', component.options)
    } else {
      api.reload('f1ad9a4e', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=f1ad9a4e&scoped=true", function () {
      api.rerender('f1ad9a4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/Checkbox/View.vue"
export default component.exports